import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {CustomerSearchDto} from "../model/CustomerSearchDto";

class CustomerSelectController {
    searchResults: CustomerSearchDto[];
    rid = 0;
    private parentGuid: string;

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.client.onCustomerSearchResult((rid, customer) => {
            if (rid !== this.rid) return;
            this.searchResults.merge(customer, x => x.guid);
        });
        $scope.$watch(() => this.parentGuid, () => this.search(null));
    }

    search = (input) => {
        this.searchResults = [];
        this.rid++;
        if (!this.$dataHub.isConnected) return;
        if (this.parentGuid)
            this.$dataHub.server.customerSearch(this.rid, input, this.parentGuid, 10);
        else
            this.$dataHub.server.customerJobSearch(this.rid, input, 10);
    }

}

export default angular.module('component.customerSelect', [])
    .component('customerSelect', {
        template: require('./CustomerSelect.html'),
        controller: CustomerSelectController,
        bindings: {
            model: '=',
            onSelect: '&',
            parentGuid: '=',
            appendToBody: '='
        }
    }).name;
